import { iPricingPlan } from "./pricing-plan-model";

export const CalculateAnnualPlanPrice = (plan: iPricingPlan) => {
  const annualPrice = Number(plan.price.slice(1))
    ? `$${Math.round((Number(plan.price.slice(1)) * 10) / 12)}`
    : plan.price;
  return annualPrice;
};
